export default "__VITE_ASSET__BKN3YoX1__"